App.controller('ContactCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'contactService', '$timeout', 'popUpService', function ($scope, $sce, $state, $http, Config, $mdDialog, contactService, $timeout, popUpService) {
    $scope.page = 'contact';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Skontaktuj się z nami';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.topics = [
        {
            title: 'Przetwarzanie danych osobowych',
            email: 'iod@xilium.pl'
        },
        {
            title: 'Problem z aplikacją',
            email: 'kontakt@xilium.pl'
        },
        {
            title: 'Pytanie dotyczące produktów',
            email: 'kontakt@xilium.pl'
        },
        {
            title: 'Pozostałe',
            email: 'kontakt@xilium.pl'
        }
    ]

    $scope.acceptedAgreement = false;
    $scope.subject = 'empty';
    $scope.text = '';

    var userObject = window.sessionStorage.getItem('userObject');
    if (userObject) {
        $scope.userObject = JSON.parse(userObject);
        $scope.email = $scope.userObject.email;
    }

    $scope.send = function(ev) {
        var vm = this;

        if (!$scope.subject || $scope.subject === 'empty') {
            ev.preventDefault();
            $scope.error = 'Wybierz temat z listy';
            return 0;
        }

        if (!vm.form.$valid) {
            return 0;
        }

        if (!$scope.acceptedAgreement) {
            $scope.showPopUp('', 'Zaakceptuj zgodę', 'Aby przesłać wiadomość zaakceptuj wymaganą zgodę.');
            return 0;
        }

    	$scope.data = {
            acceptedAgreement: $scope.acceptedAgreement,
            message: $scope.text,
            title: $scope.topics[$scope.subject].title,
            email: $scope.email
        }

        var el = $(ev.currentTarget).find('.button');
        console.log(el);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            el.addClass('disabled');
        }

	    contactService.contactForm($scope.data).then(function (data) {
	        if (data.status === 200) {
	        	$scope.showPopUp('', 'Wiadomość wysłana', 'Twoja wiadomość została wysłana poprawnie, skontaktujemy się z Tobą możliwie najszybciej.');

	        	$scope.subject = 'empty';
			    $scope.text = '';
                $scope.email = '';

                $scope.error = '';
                vm.form.$setPristine();
                vm.form.$setUntouched();
                vm.form.$submitted = false;
	        }

            $timeout(function() {
                el.removeClass('disabled');
            }, 1500);
	    });
    }

    $scope.moreInfo = function() {
        $scope.showPopUpMoreInfo('');
    };

    $scope.showPopUpMoreInfo = function(ev) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-contact-more.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {

            }
        }).then(function(data) {
            
        }, function() {
            
        });
    };

    $scope.showPopUp = function(ev, head, content) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
            	head: head,
            	content: content
            }
        }).then(function(data) {
            
        }, function() {
            
        });
    };

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }
    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals'];

    limitedPopUp();
    function limitedPopUp() {
        let dateNow = moment().toDate();

        let dateFrom = moment('2022-09-05').toDate();
        dateFrom.setHours(15, 0, 0, 0);

        let dateTo = moment('2022-09-07').toDate();
        dateTo.setHours(18, 0, 0, 0);

        var config = {
            head: `Informacja`,
            content: `W dniach 6-7 września infolinia Xilium oraz obsługa mailowa będą nieczynne. Zapraszamy do kontaktu w kolejnym dniu roboczym.`,
            tpl: 'info-big'
        };

        if (dateNow.getTime() >= dateFrom.getTime() && dateNow.getTime() <= dateTo.getTime()) {
            popUpService.showPopUp(config);
        }
    }
}]);